// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"01a3d4fd","88":"676d70d8"}[chunkId] + ".chunk.css";
};